import { render, staticRenderFns } from "./ComplianceSettings.vue?vue&type=template&id=3f1cd224&"
import script from "./ComplianceSettings.vue?vue&type=script&lang=js&"
export * from "./ComplianceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1cd224')) {
      api.createRecord('3f1cd224', component.options)
    } else {
      api.reload('3f1cd224', component.options)
    }
    module.hot.accept("./ComplianceSettings.vue?vue&type=template&id=3f1cd224&", function () {
      api.rerender('3f1cd224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ComplianceSettings.vue"
export default component.exports